var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconService5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_28070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9328 14.7611C17.3219 14.7668 17.7083 14.695 18.0694 14.55C18.4306 14.405 18.7593 14.1897 19.0364 13.9165C19.3136 13.6434 19.5337 13.3178 19.6839 12.9588C19.8341 12.5998 19.9114 12.2145 19.9114 11.8254V11.8254C19.9114 11.0468 19.6021 10.3001 19.0515 9.7495C18.501 9.19895 17.7543 8.88965 16.9757 8.88965H12.4542C12.1701 8.88965 11.8976 9.00253 11.6966 9.20346C11.4957 9.40439 11.3828 9.67692 11.3828 9.96108V20.6754C11.3828 20.9595 11.4957 21.232 11.6966 21.433C11.8976 21.6339 12.1701 21.7468 12.4542 21.7468H16.9328C17.8535 21.7468 18.7365 21.3811 19.3875 20.73C20.0385 20.079 20.4042 19.196 20.4042 18.2754C20.4042 17.3547 20.0385 16.4717 19.3875 15.8207C18.7365 15.1697 17.8535 14.8039 16.9328 14.8039V14.7611Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9757 14.7607H11.3828",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4189 8.8894V6.91797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 8.8894V6.91797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.418 24.0612V21.7041",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 24.0612V21.7041",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0467 29.4177C22.7393 29.4177 28.9753 23.1817 28.9753 15.4891C28.9753 7.79658 22.7393 1.56055 15.0467 1.56055C7.3542 1.56055 1.11816 7.79658 1.11816 15.4891C1.11816 23.1817 7.3542 29.4177 15.0467 29.4177Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_28070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.046875 0.489258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService5);
export default __webpack_public_path__ + "static/media/icon-service-5.d76a7ada466d9bbf71a0f286717dda58.svg";
export { ForwardRef as ReactComponent };